<script setup lang="ts">

import {useRoute} from "vue-router";
import FraudReportCard from "@/patient-administration/components/FraudReportCard.vue";
import useSwr from "@/core/composables/swr/useSwr";
import {computed} from "vue";
import {cacheKey} from "@/lib/cache";
import {asafoApi} from "@/container";
import TheBackButton from "@/core/components/navigation-bar/TheBackButton.vue";
import dateHelper from "@/core/helpers/dateHelper";
import formatHelper from "@/core/helpers/formatHelper";

const route = useRoute();

/**
 * Fetches fraud reports from the ASAFO API.
 * Uses SWR for data fetching and caching.
 */
const {data} = useSwr(
    computed(() => cacheKey(`fraud-report-customers/${route.params.id}`)),
    () => asafoApi().readCustomer(parseInt(route.params.id as string)),
);
</script>

<template>
  <div v-if="data" class="flex flex-col gap-4 p-6">
    <div class="flex items-center text-sm">
      <TheBackButton class="p-0" />
      <div>
        <div>
          <span class="font-bold">{{ formatHelper.patientName(data) }}</span>
          - né le {{ dateHelper.dayOnlyLongFormat(data.birth_date) }}
        </div>
        <div>{{ data.nir }}</div>
      </div>
    </div>
    <FraudReportCard v-for="report in data.reports" :key="report.asafo_key" :report="report" />
  </div>
</template>
